import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

// PAGES
import APIExplorer from './Pages/APIExplorer/APIExplorer';
import Home from './Pages/Home/Home';
// import Account from './Pages/Account/Account';
// import Settings from './Pages/Settings/Settings';
import Warning from './Pages/Warning/Warning';
import Proto from './Pages/Proto/Proto';

import './App.scss';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // force top scroll on page mount / refresh
  componentDidMount() {
    setTimeout(() => window.scrollTo(0, 0), 100); // eslint-disable-line
  }

  render() {
    return (
      <Router>
        <div className="mainWrapper">
          <Switch>
            <Route exact path="/feature" component={Proto} />
            <Route exact path="/account" component={Proto} />
            <Route exact path="/settings" component={Proto} />
            <Route exact path="/api" component={APIExplorer} />
            <Route exact path="/warning" component={Warning} />
            <Route exact path="/" component={Home} />
            <Redirect to="/" />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;
